import React, {
  createContext,
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import { getErtDetail, getstatus, getDownloadExcel } from "../../api/Api";

export const StatusERTContext = createContext({});
export const StatusERTContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const ertExcelSheet = location?.state?.ertExcelSheet;
  const previousPage = location?.state?.status;
  const ertData = location?.state?.filteredData;
  const ertcategoryList = location?.state?.ertList;
  const downloadexcel = location?.state?.excelData;
  const [statusData, setStatusData] = useState(ertData ? ertData : []);
  const [showAlert, setShowAlert] = useState(false);
  const [zoneNewExcel, setZoneNewExcel] = useState("");
  const [ertExcelData, setExcelData] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [statusCode, setStatusCode] = useState(0);
  const [dataLoad, setDataLoad] = useState(false);
  const arrayOfIds = ertData.map((item) => {
    return item.id;
  });

  const handleAlertSubmit = () => {
    setShowAlert(false);
  };
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const emptyERTAlert = () => {
    setAlertMessage("No users listed under this category");
    setShowAlert(true);
  };

  const goBack = () => {
    navigate(-1);
  };

  const [statusCategory, setStatusCategory] = useState([]);

  const restructureApiResponse = (data) => {
    const iteratedObject = data?.map((item) => {
      return {
        categoryName: item?.name ? item.name : 0,
        totalCount: item?.total ? item.total : 0,
        zoneOneCount: item?.category?.[0]?.total
          ? item.category?.[0]?.total
          : 0,
        zoneTwoCount: item?.category?.[1]?.total
          ? item.category?.[1]?.total
          : 0,
        ertId: item?.id ? item.id : "",
      };
    });
    return iteratedObject;
  };
  const getStatusData = async () => {
    try {
      const getData = await getstatus("ert", "");
      if (getData.data.status === 200) {
        const filteredData = getData?.data?.data?.status;
        setStatusData(getData?.data?.data?.status);
      }
    } catch (error) {
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;

        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  const downloadExcelSheet = async () => {
    setSpinnerStatus(true);
    const data = {
      search: "status",
      filter: "ert",
      empData: "",
      fromDate: "",
      toDate: "",
      zoneFilter: "",
      categoryFilter: "",
    };
    try {
      const response = await getDownloadExcel(data);
      if (response.data.status === 200) {
        setSpinnerStatus(false);
        setZoneNewExcel(response?.data?.data?.filename);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  useEffect(() => {
    downloadExcelSheet();
  }, []);
  useEffect(() => {
    setExcelData(downloadexcel);
    const statusDataFiltered = ertcategoryList.filter((item, index) => {
      if (!arrayOfIds.includes(item.id)) {
        return item;
      }
    });
    statusData.push(...statusDataFiltered);

    const iteratedResponse = restructureApiResponse(statusData);
    setStatusCategory(iteratedResponse);
  }, [statusData]);

  const evacuactionDetailPage = async (pageName, ertId) => {
    setDataLoad(true);
    try {
      const getData = await getstatus("ert", ertId);
      //const getData = await getErtDetail(ertId);
      if (getData?.data?.status === 200) {
        setDataLoad(false);
        const ertDetail = getData?.data?.data?.result;
        navigate(RouteConstants.STATUS_ERT_DETAILS, {
          state: {
            pageName,
            previousPage,
            ertDetail,
          },
        });
      }
    } catch (error) {
      setDataLoad(false);
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const providerValue = {
    goBack,
    evacuactionDetailPage,
    previousPage,
    statusCategory,
    showAlert,
    setShowAlert,
    alertMessage,
    zoneNewExcel,
    statusCode,
    logout,
    ertExcelData,
    handleAlertSubmit,
    dataLoad,
    emptyERTAlert,
    spinnerStatus,
  };
  return (
    <StatusERTContext.Provider value={providerValue}>
      {children}
    </StatusERTContext.Provider>
  );
};
